import {
  SET_CHAT_MODE,
  SET_END_DOCUMENT_MODE,
  SET_DOCUMENT_MODE,
  SET_SHOW_FILE_VIEW
} from '../actions/chatbotActions'

const initialState = {
  chatMode: 'chat',
  documentMode: {
    active: false,
    files: []
  },
  endDocumentMode: false,
  showFileView: false
}

export default function chatbotReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CHAT_MODE: {
      return {
        ...state,
        chatMode: action.payload
      }
    }
    case SET_END_DOCUMENT_MODE: {
      return {
        ...state,
        endDocumentMode: action.payload
      }
    }
    case SET_DOCUMENT_MODE: {
      return {
        ...state,
        documentMode: {
          ...state.documentMode,
          active: action.payload.active,
          files: action.payload.files
        }
      }
    }
    case SET_SHOW_FILE_VIEW: {
      return {
        ...state,
        showFileView: action.payload
      }
    }
    default:
      return state
  }
}
